import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type TMutationConfig = {
  useSuccessMessage?: boolean | null;
  useErrorMessage?: boolean | null;
  successMessage?: string | null;
  errorMessage?: string | null;
  shouldTranslate?: boolean;
};

interface IUseMetaMutateProps<TData, TError, TVariables, TContext>
  extends UseMutationOptions<TData, TError, TVariables, TContext> {
  config?: TMutationConfig;
}

const useMutate = <TData, TError, TVariables, TContext>({
  config,
  ...rest
}: IUseMetaMutateProps<TData, TError, TVariables, TContext>) => {
  const {
    useSuccessMessage = true,
    useErrorMessage = true,
    errorMessage = undefined,
    successMessage = undefined,
    shouldTranslate = false,
  } = config || {
  };

  return useMutation({
    meta: {
      useSuccessMessage,
      useErrorMessage,
      errorMessage,
      successMessage,
      shouldTranslate,
    },
    ...rest,
  });
};

export default useMutate;
